export enum ROUTE_TYPE {
  public,
  private,
}
interface ROUTE {
  path: string;
  type: ROUTE_TYPE;
  navigate?: any;
}

export const HOME_ROUTE: ROUTE = { 
  path: '/', 
  type: ROUTE_TYPE.public 
};

export const TEST_ATTEMPT_ROUTE: ROUTE = {
  path: '/test-attempt/:attemptId',
  type: ROUTE_TYPE.private,
};

export const MOCK_TEST_ROUTE: ROUTE = {
  path: '/mock-tests',
  type: ROUTE_TYPE.private,
};

export const DASHBOARD_ROUTE: ROUTE = {
  path: '/dashboard',
  type: ROUTE_TYPE.private,
};

export const ONBOARDING_ROUTE: ROUTE = {
  path: '/onboarding',
  type: ROUTE_TYPE.private,
};

export const TEST_RESULT_ROUTE: ROUTE = {
  path: '/test-result/:attemptId',
  type: ROUTE_TYPE.private,
  navigate: (attemptId: string) => `/test-result/${attemptId}`,
};

export const TEST_ATTEMPT_PREVIEW_ROUTE: ROUTE = {
  path: '/test-attempt-preview/:attemptId',
  type: ROUTE_TYPE.private,
  navigate: (attemptId: string) => `/test-attempt-preview/${attemptId}`,
};

export const EXAM_DETAILS_ROUTE: ROUTE = {
  path: '/exam-details/:examIdentifier',
  type: ROUTE_TYPE.public,
  navigate: (examIdentifier: string) => `/exam-details/${examIdentifier}`,
};

export const WORK_WITH_US_ROUTE: ROUTE = {
  path: '/work-with-us',
  type: ROUTE_TYPE.public,
};

export const BECOME_A_MENTOR_ROUTE: ROUTE = {
  path: '/become-a-mentor',
  type: ROUTE_TYPE.public,
};

export const ABOUT_US_ROUTE: ROUTE = {
  path: '/about-us',
  type: ROUTE_TYPE.public,
};

export const PRIVACY_POLICY_ROUTE: ROUTE = {
  path: '/privacy-policy',
  type: ROUTE_TYPE.public,
};

export const TERMS_AND_CONDITIONS_ROUTE: ROUTE = {
  path: '/terms-and-conditions',
  type: ROUTE_TYPE.public,
};

export const TERMS_OF_USE_ROUTE: ROUTE = {
  path: '/terms-of-use',
  type: ROUTE_TYPE.public,
};

export const REFUND_AND_CANCELLATION_ROUTE: ROUTE = {
  path: '/refund-and-cancellation',
  type: ROUTE_TYPE.public,
};

export const CONTACT_US_ROUTE: ROUTE = {
  path: '/get-in-touch',
  type: ROUTE_TYPE.public,
};

export const TEST_PREPARATION_MODE_ROUTE: ROUTE = {
  path: '/test-preparation-mode/:testId',
  type: ROUTE_TYPE.private,
  navigate: (testId: string) => `/test-preparation-mode/${testId}`,
};

export const OUR_INSTITUTES_ROUTE: ROUTE = {
  path: '/contact-us',
  type: ROUTE_TYPE.public,
};

export const YOUR_COMPANION_ROUTE: ROUTE = {
  path: '/your-companion',
  type: ROUTE_TYPE.public,
};

export const FAQ_ROUTE: ROUTE = {
  path: '/faq',
  type: ROUTE_TYPE.public,
};

export const WEBINAR_SLPRB_ROUTE: ROUTE = {
  path: '/webinar/slprb-2026',
  type: ROUTE_TYPE.public,
};

export const OPPORTUNITIES_ROUTE: ROUTE = {
  path: '/opportunities',
  type: ROUTE_TYPE.public,
};

export const PROFILE_ROUTE: ROUTE = {
  path: '/profile',
  type: ROUTE_TYPE.private,
};

export const DATA_DELETION_ROUTE: ROUTE = {
  path: '/data-deletion',
  type: ROUTE_TYPE.public,
};

export const DOWNLOAD_APP_ROUTE: ROUTE = {
  path: '/download',
  type: ROUTE_TYPE.public,
};

export const FIND_A_TUTOR_ROUTE: ROUTE = {
  path: '/find-a-tutor-near-me',
  type: ROUTE_TYPE.public,
};

export const BECOME_A_TUTOR_ROUTE: ROUTE = {
  path: '/become-a-tutor',
  type: ROUTE_TYPE.public,
};

export const TEST_SERIES_ROUTE: ROUTE = {
  path: '/test-series',
  type: ROUTE_TYPE.public,
};

export const SUBSCRIPTION_ROUTE: ROUTE = {
  path: '/subscription',
  type: ROUTE_TYPE.public,
};